import gql from 'graphql-tag';

export const GetLoginUser = gql`
	query GetLoginUser(
		$cognitoId: ID
		$accountClaim: AWSJSON
		$token: AWSJSON
		$emailAddress: String
		$employeeId: String
		$companyId: ID
		$userId: ID
	) {
		getLoginUser(
			cognitoId: $cognitoId
			accountClaim: $accountClaim
			token: $token
			emailAddress: $emailAddress
			employeeId: $employeeId
			companyId: $companyId
			userId: $userId
		) {
			id
			admin
			authMethod
			accountClaimId
			accountClaim {
				id
				active
				eligible
				employeeId
				firstName
				lastName
				dateOfBirth
				title
				department
				atsId
				middleName
				isRehire
				customValues
			}
			careerProfile
			cognitoId
			companyId
			company {
				id
				name
				defaultBonusAmount
				contactIncentiveBonus
				websiteUrl
				dashboardReferralPolicyText
				referralBonusWaitingPeriod
				referralLeadsAllowDuplicateContacts
				bonusEarnedNote
				allowSelfReferrals
				allowInternalMobility
				ATSProcessingConfig
				internalMobilityImage {
					bucket
					region
					key
				}
				dateCreated
				brandColor
				accountType
				logo {
					bucket
					region
					key
				}
				employeeDashboard
				employeeDashboardRows
				ignoreSubcompany
				enableGenericReferralEmail
				enableLead
				hideSubcompanyOnAcceptancePage
				hideSubcompanyOnSignup
				hideSubcompanyOnJobs
				sendReferralColor
				applyInternallyColor
				generalReferralColor
				referralLeadColor
				disableSmartReferrals
				disableSAMLLogin
				disableClaimYourAccountLogin
				confirmCompliance
				platformConfig
				ssoGoogleDomain
				confirmContactEmails
				whiteLabel
				whiteLabelSettings
				SFTPProcessingConfig
				showPoweredByErin
				stages
				API {
					googleClientId
					microsoftClientId
				}
				theme
				symbol {
					bucket
					region
					key
				}
				background {
					bucket
					region
					key
				}
				errorImage {
					bucket
					region
					key
				}
				socialImage {
					bucket
					region
					key
				}
				departments {
					active
					companyId
					id
					name
					keywords
				}
				userGroups {
					companyId
					id
					name
					keywords
				}
				subCompanies {
					companyId
					id
					name
					keywords
				}
				enableGeneralReferrals
				referralStatus
				referralCustomStatuses
				requireBonusChangeReason
				disableManagerPermissions
				disableManagerPermissionsByType
				hideCopyReferral
				hideJobsPage
				disableShareLink
				disableNewReferralSMSNotification
				helpUrl
				privacyUrl
				termsUrl
				linkUrl
				linkName
				enableProspectCreation
				allowSelfReferralsInternalLink
				sendAdminNotificationsOnReferral
				sendAdminNotificationsOnInternalCandidatesFound
				enableAcceptedReferralReminder
				disableExtendedUserJobsView
				enableExtendedNetwork
				enableCareerProfile
				enableJobMatching
				enableJobNotifications
				enableRecognition
				gifIds
				externalUserSignUp
				hideLoginForm
				hideMessageRecruiter
				hidePaymentInfoJobCard
				disableReferrals
				hideBonus
				includeAdminInRanking
				disableSite
				hideInterestedForGroup
				senderEmailAddress
				whiteLabelServiceName
				host
				hideShareLinkForDepartment
				hideShareLinkNoPublicUrl
				hideDateCreatedJobDetails
				hideBonusFilterOnBrowseJobs
				jobFilterSettings
				jobNotificationSetting
				jobNotificationFrequency
				subCompanyLabel
				labelDepartment
				labelSocialShare
				sftpFolderName
				defaultLocation
				labelEmployeeID
				giftCardStoreAPIKeys {
					apiKey
					region
				}
				giftCardStoreBalance
				giftCardStorePendingBalance
				enableCustomDashboard
				enableCustomNav
				customNav
				customDashboard
				enableDashboardSearch
				dashboardSearchBG {
					key
					bucket
					region
				}
				userEditSettings
				userSignupSettings
				publicLeaderboard
				hideReferralsRanking
				pointsSettings
				popupTitle
				popupTitleContent
				partnerHostId
				preStartEnabled
				preStartUserGroupId
				hideWhatsApp
				hideRecruiterInfo
				hideRecruiterInfoJobDetails
				showRecruiterInfoJobCard
				resetPopup
				defaultToSubcompany
				internalMobilityCustomTitle
				appStoreUrls {
					ios
					android
				}
				bonusReportFrequency
				employeeReportFrequency
				referralsReportFrequency
				referralsReportDateRange
				recognitionSettings {
					allowRecognitionsForAccountClaims
					allowSelfNominations
					recognitionAnnouncementText
					recognitionCategories
					recognitionCustomTitle
					recognitionHashtags
					requireBadgeSelection
					requireBadgeAssignmentMessage
					customModal {
						title
						content
						isEnabled
						showEachLogin
					}
					hideRecognitionSocialShare
					hideRecognitionLeaderboard
					hideAllRecognitionsManager
					catalogOnlyGroupedByCategory
					customSendRecognitionBoxText
					customSendToPeerText
					disableRecHub
					disableNominations
					disableReplies
					disableReplyNotifications
					displayPointsAsCurrency
					recognitionPointsCurrency
					notificationOnApprovalDecision
					allowAdminBalanceOverrides
					rewardsEarnedMechanism
					baseSnappyBudget
					nominatedRecognitionsCostPoints
					enableManagerSendForm
					requireJustification
					requireAdminApproval
					assignSnappyRewardToRecognition
					tieredRewardsCampaign {
						id
						name
						description
						snappyGrantId
						snappyGrant {
							id
							externalSnappyId
							snappyCampaignId
							name
							description
							costInCurrency
						}
						unlockConditionType
						unlockConditionAmount
					}
					milestoneColorMap {
						years
						color
					}
					milestoneClaimExpiryDays
					milestoneClaimModalTitle
					milestoneClaimModalMessage
				}
				countryCode
				metabaseReports {
					id
					label
					reportId
					reportType
				}
			}
			contacts {
				id
				firstName
				lastName
				importMethod
				emailAddress
				phoneNumber
			}
			emailAddress
			role
			firstName
			lastName
			title
			avatar {
				bucket
				region
				key
			}
			departmentId
			department {
				id
				name
				companyId
			}
			disableReplyNotifications
			extendedCompanies
			extendedCompaniesData {
				id
				name
				disableExtendedUserJobsView
				enableExtendedNetwork
				enableCareerProfile
				enableJobMatching
			}
			extendedContactIds
			extendedContactData {
				id
				firstName
				lastName
				importMethod
				emailAddress
				phoneNumber
				extendedUserId
				userId
				user {
					id
					cognitoId
					firstName
					lastName
					emailAddress
					companyId
				}
			}
			userGroupId
			userGroup {
				id
				measurement
				name
				currency
				languageCode
				companyId
			}
			lastLogin
			lastNotificationCheck
			incentiveEligible
			inviteStatus
			totalReferrals
			active
			managedDepartments {
				departmentId
				department {
					id
					name
				}
			}
			connectedApps
			location
			currency
			createdById
			employeeId
			languageCode
			dateFormat
			isAllowJobNotification
			isScopedUser
			defaultDistance
			scopedPolicy
			search
			subCompanyId
			subCompany {
				companyId
				id
				logo {
					bucket
					key
					region
				}
				name
			}
			accessToken
			expires
			expirationDoneByToken
			openToNewRole
			jobNotificationSetting
			jobNotificationFrequency
			enableJobNotifications
			enableRecognition
			isOptoutAnalytics
			isOptoutReferralNotification
			points
			milestoneYears
			recognitionEvents {
				currentBudget
				amountPending
				additionalBudgetTotal
				hasSeenPopup
				lastUpdated
				eventList {
					adminOverride
					approvalResult
					budgetAfterTotal
					budgetBeforeTotal
					completedById
					completedDate
					createdDate
					pendingApproval
					recognitionAmount
					recognitionId
					recognitionName
					sentById
					sentByManager
					sentReason
					snappyCampaignTierId
					snappyGrantId
				}
			}
		}
	}
`;
